import { DestroyRef, Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { ToastComponent } from '../../shared/components/toast/toast.component';
import { errorMessages } from '../utils/sm-error-messages';
import { InstanceIdService } from '@shared/services/instance-id.service';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private instanceId: string;

  private ERROR_DURATION: number = 3000;

  private INFO_DURATION: number = 2000;

  constructor(
    private snackBar: MatSnackBar,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
  }

  displayToast(
    message: string,
    duration: number,
    isError?: boolean,
    isYellow?: boolean,
    isRefresh?: boolean,
    actionLabel?: string
  ): MatSnackBarRef<ToastComponent> {
    return this.snackBar.openFromComponent(ToastComponent, {
      data: {
        message: message,
        isError: isError,
        isYellow: isYellow,
        isRefresh: isRefresh,
        actionLabel: actionLabel,
        icon: isError ? 'cancel' : isRefresh ? 'refresh' : isYellow ? 'warning' : 'check_circle',
      },
      duration: duration,
      panelClass: isError
        ? 'toast-error'
        : isRefresh
          ? 'refresh-page-notification'
          : isYellow
            ? 'toast-yellow'
            : 'toast-info',
      horizontalPosition: isRefresh ? 'right' : 'center',
      verticalPosition: isRefresh ? 'top' : 'bottom',
    });
  }

  errorToast(codeOrMessage: string, time?: number): MatSnackBarRef<ToastComponent> {
    if (codeOrMessage in errorMessages) {
      codeOrMessage = errorMessages[codeOrMessage];
    }
    return this.displayToast(codeOrMessage, time ? time : this.ERROR_DURATION, true);
  }

  infoToast(message: string): MatSnackBarRef<ToastComponent> {
    return this.displayToast(message, this.INFO_DURATION);
  }

  displayNewUpdateAvailableToast(): void {
    const toastRef: MatSnackBarRef<ToastComponent> = this.displayToast(
      'Une nouvelle mise à jour est disponible. Veuillez enregistrer vos modifications puis actualiser la page.',
      0,
      false,
      false,
      true,
      'Actualiser'
    );

    this.subscriptionManager
      .createRequest(toastRef.onAction(), 'displayNewUpdateAvailableToast', this.instanceId)
      .subscribe({
        next: () => {
          window.location.reload();
        },

        error: (error: any) => {
          let tipMessage: string = 'app/unknown-error';
          if (error && error.name === 'HttpErrorResponse' && !error.status) {
            tipMessage = 'app/network-error';
          } else if (error) {
            if (error.error) {
              error = error.error;
            }
            if (error.code) {
              tipMessage = error.code.toString();
            }
          }
          tipMessage = tipMessage.substring(0, 500);
          this.errorToast(tipMessage);
        },
      });
  }
}
